module.exports = __webpack_public_path__ + "static/img/200200.2cf08517.png";